import { FC, Fragment } from 'react';
import { Divider } from 'antd';
import FleetTitle from '@/libs/antd/components/Title';
import { useUserData } from '@/libs/fleet-api/hooks';
import FRMThingsToDo from '@/components/todo/FRMThingsToDo';
import CCAThingsToDo from '@/components/todo/CCAThingsToDo';
import FBDHThingsToDo from '@/components/todo/FBDHThingsToDo';
import CCDHThingsToDo from '@/components/todo/CCDHThingsToDo';
import CHThingsToDo from '@/components/todo/CHThingsToDo';
import FHThingsToDo from '@/components/todo/FHThingsToDo';
import FSThingsToDo from '@/components/todo/FSThingsToDo';
import SCThingsToDo from '@/components/todo/SCThingsToDo';
import FCOHThingsTodo from '@/components/todo/FCOHThinsTodo';
import FCOMThingsTodo from '@/components/todo/FCOMThinsTodo';
import FCDVSThingsTodo from '@/components/todo/FCDVSThinsTodo';
import FCASThingsTodo from '@/components/todo/FCASThinsTodo';
import FCSThingsTodo from '@/components/todo/FCSThingsTodo';

const DashboardPage: FC = () => {
	const userData = useUserData();
	const { groupName } = userData ?? {};

	const getThingsToDo = () => {
		switch (groupName) {
			case 'FRM':
				return <FRMThingsToDo />;
			case 'FBDH':
				return <FBDHThingsToDo />;
			case 'CCA':
				return <CCAThingsToDo />;
			case 'CCDH':
				return <CCDHThingsToDo />;
			case 'CH':
				return <CHThingsToDo />;
			case 'FH':
				return <FHThingsToDo />;
			case 'FS':
				return <FSThingsToDo />;
			case 'SECOM':
				return <SCThingsToDo />;
			case 'FCOH':
				return <FCOHThingsTodo />;
			case 'FCOM':
				return <FCOMThingsTodo />;
			case 'FCDVS':
				return <FCDVSThingsTodo />;
			case 'FCAS':
				return <FCASThingsTodo />;
			case 'FCS':
				return <FCSThingsTodo />;
			default:
				return '';
		}
	};

	return (
		<Fragment>
			<FleetTitle level={2}>Things To Do</FleetTitle>
			<Divider />
			{getThingsToDo()}
		</Fragment>
	);
};

export default DashboardPage;
